import React from 'react';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import ContactInfo from '../components/ContactInfo';
import ContactForm from '../components/ContactForm';
import FollowUs from '../components/FollowUs';

const Contact = () => {
    return (
        <>
            <Meta title="Contact Us - THE CUTTING BAR" />
            <PageBanner imageUrl="assets/images/background/5.jpg" heading="Contact Us" />
            <ContactInfo />
            <ContactForm />
            <FollowUs />
        </>
    );
}

export default Contact;
